import "./AllProducts.css";

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Carousel from "react-multi-carousel";

import "react-multi-carousel/lib/styles.css";
function CategoryProducts({ productCategory }) {
  const [categoryProducts, setCategoryProducts] = useState([]);
  useEffect(() => {
    const categoryProducts = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACK}/${productCategory}`
      );

      setCategoryProducts([...response.data]);
    };
    categoryProducts();
  }, [productCategory]);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    categoryProducts && (
      <div>
        {/* <hr className="fw-bold " /> */}
        <h3 className="text-center mt-5 h4 color-green">
          People who bought this product also took the followings:
        </h3>
        <div className="mt-5 carousel container mb-5">
          <Carousel responsive={responsive} infinite={true}>
            {categoryProducts.map((product) => {
              return (
                <div key={product.id}>
                  <h5 className="text-center ms-2 me-2 ">{product.name}</h5>
                  <h6 className="fw-bold">US$ {product.price}</h6>
                  <Link to={`/product/${product.slug}`}>
                    <img
                      className="allImg mb-4"
                      src={`
                      ${process.env.REACT_APP_FILES_URL}/${product.image}
                    `}
                      alt="First slide"
                    />
                  </Link>
                </div>
              );
            })}
          </Carousel>
        </div>
      </div>
    )
  );
}

export default CategoryProducts;
